<template>
  <b-container class="index" v-if="showPage && !eventPage" fluid="sm">
    <img
      class="background_up_right"
      src="/img/campaign/reality_memories_2024/background_up_right.png"
    />
    <img
      v-if="isJapanese"
      class="logo"
      src="/img/campaign/reality_memories_2024/logo_jp.png"
    />
    <img
      v-else
      class="logo"
      src="/img/campaign/reality_memories_2024/logo_en.png"
    />

    <div class="Frame1">
      <div class="Group1-1">
        <div class="Group1-1-1">
          <p class="text1" v-if="isJapanese">今年、REALITYを</p>
          <p class="text1" v-else>This year, you were</p>
          <div class="text2">
            <p class="theme_Liner_2022-to-2023">
              {{ data.totalLoginDays.toLocaleString() }}
            </p>
            <img src="/img/campaign/reality_memories_2024/days.png" />
          </div>
          <p class="text3" v-if="isJapanese">遊びました！</p>
          <p class="text3" v-else>in REALITY!</p>
        </div>
        <div class="Group1-1-2">
          <img :src="data.streamerUser.iconUrl + '/256'" />
        </div>
      </div>
      <div class="Frame1-2" v-if="isExistData()">
        <div class="Frame1-2-2">
          <p class="theme_gray" style="text-shadow: 1px 1px 2px #0f0f4d;">
            {{ $t('memoriesNoteText1', { date: makeDataDate }) }}
          </p>
          <div class="ResultFrame1 left">
            <p class="title theme_gray">{{ $t('totalViewingTime') }}</p>
            <p class="hour theme_accent80">
              {{ data.myRecord.totalBroadcastViewHour.toLocaleString() }}h
            </p>
            <img src="/img/campaign/reality_memories_2024/icon_play.png" />
          </div>
          <div class="ResultFrame1 right">
            <p class="title theme_gray">{{ $t('totalBroadcastingTime') }}</p>
            <p class="hour theme_accent80">
              {{
                data.myRecord.totalBroadcastHour == 0
                  ? '--'
                  : data.myRecord.totalBroadcastHour.toLocaleString() + 'h'
              }}
            </p>
            <img src="/img/campaign/reality_memories_2024/icon_video.png" />
          </div>
        </div>

        <!-- イベント入賞履歴 -->
        <div class="Group1-2-3" v-if="data.myRecord.winEvents.length > 0">
          <div class="Frame1-2-3-1">
            <p class="title theme_gray">{{ $t('memoriesMajorEventAwards') }}</p>
            <template v-for="n of 2">
              <event-info :data="data.myRecord.winEvents[n - 1]" :key="n" />
            </template>
          </div>
          <img
            class="BackIcon"
            src="/img/campaign/reality_memories_2024/icon_event.png"
          />
          <div
            class="OpenButton"
            v-if="data.myRecord.winEvents.length > 2"
            @click="onClickOpenAllEvent"
          >
            <p class="theme_accent80">
              {{ $t('memoriesViewAll') }}
            </p>
          </div>
        </div>

        <!-- シェアボタン -->
        <template v-if="canUserNativeInterface">
          <div class="share_button" @click="onClieckShare">
            {{ $t('memoriesShareText1') }}
            <img src="/img/campaign/reality_memories_2024/icon_share.png" />
          </div>
        </template>
      </div>
      <div class="Group1-3" v-else>
        <p class="theme_gray">
          {{ $t('memoriesNoteText1', { date: makeDataDate }) }}
        </p>
        <div class="Group1-3-1">
          <img src="/img/campaign/reality_memories_2024/empty_bear.png" />
          <p>
            {{ $t('memoriesNoteText2') }}
          </p>
        </div>
      </div>
    </div>

    <div class="Group2" v-if="isExistData() && categoryDescription.length > 0">
      <img
        class="background_center_left"
        src="/img/campaign/reality_memories_2024/background_center_left.png"
      />
      <div class="Group2-1">
        <div class="Group2-1-3">
          <img :src="data.streamerUser.iconUrl + '/256'" />
        </div>
        <div class="Frame2-1-1">
          <p v-if="isJapanese">あなたと友達の記録を</p>
          <p v-else style="font-size: 16px">Look back on</p>
        </div>
        <div class="Frame2-1-2">
          <p v-if="isJapanese">振り返ろう！</p>
          <p v-else style="font-size: 16px">your stats with friends!</p>
        </div>
      </div>
      <div class="Group2-2">
        <div class="Frame2-2-1">
          <p>{{ $t('memoriesHeaderText3') }}</p>
        </div>
        <div class="Group2-2-2">
          <friend-info
            v-for="(data, i) in categoryDescription"
            :key="i"
            :data="data"
          />
        </div>
      </div>
    </div>

    <div class="Frame3" v-if="isExistData()">
      <!-- 視聴に関するカテゴリ -->
      <div class="Group3-1" v-if="data.broadcastViewRecords.length > 0">
        <div class="Group3-1-2">
          <p class="title">{{ $t('memoriesMostViewed') }}</p>
          <p class="name theme_accent80">
            {{ data.broadcastViewRecords[0].streamerUser.nickname }}
          </p>
          <p class="description">
            <template v-if="isJapanese">
              <span class="theme_accent80">
                {{ fullDate(data.broadcastViewRecords[0].firstViewAt) }}
              </span>
              に今年は初めて視聴し、
              <span class="theme_accent80">
                {{
                  data.broadcastViewRecords[0].totalViewHour.toLocaleString()
                }}
              </span>
              時間ともに過ごしました。
            </template>
            <template v-else>
              You've spent
              <span class="theme_accent80">
                {{
                  data.broadcastViewRecords[0].totalViewHour.toLocaleString()
                }}h
              </span>
              with them since this year, 
              <span class="theme_accent80">
                {{ fullDate(data.broadcastViewRecords[0].firstViewAt) }}.
              </span>
            </template>
          </p>
          <div
            class="Group3-1-2-1"
            v-if="data.broadcastViewRecords.length >= 2"
          >
            <category-friend-info
              :broadcastViewRecord="data.broadcastViewRecords[1]"
              :number="0"
            />
            <category-friend-info
              v-if="data.broadcastViewRecords.length >= 3"
              :broadcastViewRecord="data.broadcastViewRecords[2]"
              :number="1"
            />
          </div>
        </div>
        <div class="Group3-1-1">
          <img
            :src="data.broadcastViewRecords[0].streamerUser.iconUrl + '/256'"
          />
        </div>
      </div>

      <!-- ギフトに関するカテゴリ -->
      <div class="Group3-2" v-if="data.giftRecords.length > 0">
        <div class="Group3-2-2">
          <p class="title">{{ $t('memoriesMostSentGift') }}</p>
          <p class="name theme_accent80">
            {{ data.giftRecords[0].giftReceiver.nickname }}
          </p>
          <p class="description">
            <template v-if="isJapanese">
              <span class="theme_accent80">
                {{ fullDate(data.giftRecords[0].firstGiftSendAt) }}
              </span>
              に今年は初めてギフトを送り、いままで
              <span class="theme_accent80">
                {{ data.giftRecords[0].totalGiftSendCount.toLocaleString() }}
              </span>
              個送りました。
              <br />
              <template v-if="data.giftRecords[0].mostSendGift">
                とくに「
                <span class="theme_accent80">
                  {{ data.giftRecords[0].mostSendGift.giftName }}
                </span>
                」を
                <span class="theme_accent80">
                  {{
                    data.giftRecords[0].mostSendGift.giftCount.toLocaleString()
                  }}
                </span>
                個送りました。
              </template>
            </template>
            <template v-else>
              You've sent
              <span class="theme_accent80">
                {{ data.giftRecords[0].totalGiftSendCount.toLocaleString() }}
              </span>
              gift(s) since this year, 
              <span class="theme_accent80">
                {{ fullDate(data.giftRecords[0].firstGiftSendAt) }}
              </span>
              <template v-if="data.giftRecords[0].mostSendGift">
                including a
                <span class="theme_accent80">
                  {{ data.giftRecords[0].mostSendGift.giftName }}
                  {{
                    data.giftRecords[0].mostSendGift.giftCount.toLocaleString()
                  }}
                </span>
                time(s)!
              </template>
              <template v-else>!</template>
            </template>
          </p>
          <img
            class="gift_icon"
            v-if="data.giftRecords[0].mostSendGift"
            :src="data.giftRecords[0].mostSendGift.giftIconUrl"
          />
          <div class="Group3-2-2-1" v-if="data.giftRecords.length >= 2">
            <category-friend-info
              :giftRecord="data.giftRecords[1]"
              :number="0"
            />
            <category-friend-info
              v-if="data.giftRecords.length >= 3"
              :giftRecord="data.giftRecords[2]"
              :number="1"
            />
          </div>
        </div>
        <div class="Group3-2-1">
          <img :src="data.giftRecords[0].giftReceiver.iconUrl + '/256'" />
        </div>
      </div>

      <!-- コラボに関するカテゴリ -->
      <div class="Group3-3" v-if="data.collabRecords.length > 0">
        <div class="Group3-3-2">
          <p class="title">{{ $t('memoriesMostCollab') }}</p>
          <div style="text-align: center">
            <p class="name theme_accent80">
              {{ data.collabRecords[0].collabUser.nickname }}
            </p>
          </div>
          <p class="description">
            <template v-if="isJapanese">
              今年は
              <span class="theme_accent80">
                {{ data.collabRecords[0].totalCollabHour.toLocaleString() }}
              </span>
              時間、一緒に配信しました。
            </template>
            <template v-else>
              You've streamed
              <span class="theme_accent80">
                {{ data.collabRecords[0].totalCollabHour.toLocaleString() }}h
              </span>
              together in this year.
            </template>
          </p>
          <div class="Group3-3-2-1" v-if="data.collabRecords.length >= 2">
            <category-friend-info
              :collabRecord="data.collabRecords[1]"
              :number="0"
            />
            <category-friend-info
              v-if="data.collabRecords.length >= 3"
              :collabRecord="data.collabRecords[2]"
              :number="1"
            />
          </div>
        </div>
        <div class="Group3-3-1">
          <div class="icon_left">
            <img :src="data.streamerUser.iconUrl + '/256'" />
          </div>
          <img class="icon_x" src="/img/campaign/reality_memories_2024/x.png" />
          <div class="icon_right">
            <img :src="data.collabRecords[0].collabUser.iconUrl + '/256'" />
          </div>
        </div>
      </div>

      <!-- チャットに関するカテゴリ -->
      <div class="Group3-4" v-if="data.chatRecords.length > 0">
        <div class="Group3-4-2">
          <p class="title">{{ $t('memoriesMostChat') }}</p>
          <p class="name theme_accent80">
            {{ data.chatRecords[0].chatUser.nickname }}
          </p>
          <p class="description">
            <template v-if="isJapanese">
              今年は
              <span class="theme_accent80">
                {{ data.chatRecords[0].totalChatSendCount.toLocaleString() }}
              </span>
              回チャットを送りました。
            </template>
            <template v-else>
              You've sent
              <span class="theme_accent80">
                {{ data.chatRecords[0].totalChatSendCount.toLocaleString() }}
              </span>
              message(s) to them in this year.
            </template>
          </p>
          <div class="Group3-4-2-1" v-if="data.chatRecords.length >= 2">
            <category-friend-info
              :chatRecord="data.chatRecords[1]"
              :number="0"
            />
            <category-friend-info
              v-if="data.chatRecords.length >= 3"
              :chatRecord="data.chatRecords[2]"
              :number="1"
            />
          </div>
        </div>
        <div class="Group3-4-1">
          <img :src="data.chatRecords[0].chatUser.iconUrl + '/256'" />
        </div>
      </div>
    </div>

    <div class="Frame4">
      <!-- シェアボタン -->
      <template v-if="canUserNativeInterface">
        <div class="share_button" @click="onClieckShare">
          {{ $t('memoriesShareText1') }}
          <img src="/img/campaign/reality_memories_2024/icon_share.png" />
        </div>
      </template>
    </div>
  </b-container>
  <b-container class="index" v-else-if="showPage && eventPage" fluid="sm">
    <div class="Frame5">
      <div class="close_button" @click="onClickCloseAllEvent">
        <img src="/img/campaign/reality_memories_2024/btn_close.png" />
      </div>
      <div class="EventTitle">
        <p class="text1" v-if="isJapanese">今年の</p>
        <p class="text1" v-else>This year's</p>
        <p class="text2" v-if="isJapanese">主なイベント入賞記録</p>
        <p class="text2" v-else>Major Event Wins</p>
      </div>
      <div class="Frame5-0">
        <p class="theme_gray" style="text-shadow: 1px 1px 2px #0f0f4d;">
          {{ $t('memories__caption__not_subject_to_aggregation') }}
        </p>
      </div>
      <div class="Frame5-1">
        <p class="theme_gray">{{ $t('memoriesOrderByEventScore') }}</p>
        <event-info
          v-for="(event, i) in data.myRecord.winEvents"
          :data="event"
          :key="i"
        />
      </div>
    </div>
  </b-container>
  <not-found class="viewer__notfound" v-else></not-found>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import NotFound from '@/components/Error/NotFound.vue'
import { getToken } from '@/utils/token'
// import { EmptyData } from './data'
import { EmptyData, DummyData1 } from './data'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
import FriendInfo, {
  FriendInfoData,
} from '@/components/Campaign/RealityMemories2024/FriendInfo.vue'
import CategoryFriendInfo from '@/components/Campaign/RealityMemories2024/CategoryFriendInfo.vue'
import EventInfo from '@/components/Campaign/RealityMemories2024/EventInfo.vue'
import dayjs from 'dayjs'
import * as schema from '@/api/schema/appGatewayServer'
import { api } from '@/api/appGatewayServerApi'
import { Client, defaultNativeInterfaceClient } from '@/utils/NativeInterface'
import { getLanguage, setLanguage, resetLanguage, LANG_JA, LANG_EN } from '@/i18n'
import { redirectToTrackerURLIfNeeded } from '@/utils/adjust_redirector'

@Component({
  components: {
    NotFound,
    FriendInfo,
    CategoryFriendInfo,
    EventInfo,
  },
})
export default class RealityMemories2024 extends Vue {
  makeDataDate: string = '2024/01/01~2024/12/15'
  showEndDate: Date = new Date('2025/01/10 23:59 +0900')
  data: schema.MemoryAlbumPayload = EmptyData
  debugVliveID: string = ''
  loading = false
  eventPage = false
  screenMinWidth = 375

  created() {
    redirectToTrackerURLIfNeeded()
  }

  async beforeMount() {
    // 端末サイズの横幅が小さすぎる場合はリサイズ
    this.resize()

    // 思い出アルバムは12言語対応するとレイアウトが色々と崩れるので仕様として日英のみ対応
    // 日本語以外だったら英語にする強引な対応で (beforeUnmountで元に戻す)
    let lang = getLanguage()
    if (lang !== LANG_JA) {
      setLanguage(LANG_EN)
    }

    // デバッグ用としてコメントアウトして残してあります
    // URLにdummyの文字列を入れるとダミーデータで表示されるようになります
    if (this.$route.params.vliveId && this.$route.params.vliveId === 'dummy') {
      this.data = DummyData1
      return
    }

    // アプリ外で開いてtokenがないときはダウンロードページ
    if (getToken() === undefined) {
      this.moveDownload()
      return
    }

    // データの取得
    let post = {} as schema.MemoryAlbumParam
    if (this.$route.params.vliveId) {
      post.vliveId = this.$route.params.vliveId
    }
    await api()
      .memoryAlbum.get(post)
      .then((payload) => {
        this.data = payload
      })
      .catch(() => {})
  }

  beforeDestroy() {
    // 言語設定を元に戻す
    resetLanguage()
  }

  resize() {
    if (screen.width < this.screenMinWidth) {
      const scale = screen.width / this.screenMinWidth
      document.body.style.transform = 'scale(' + scale + ')'
      document.body.style.transformOrigin = '0 0'
      document.body.style.margin = '0'
    }
  }

  moveDownload() {
    this.$router.push({
      name: 'download',
    }).catch(() => {})
  }

  get showPage(): boolean {
    const time = new Date()
    return time.getTime() <= this.showEndDate.getTime()
  }

  isExistData(): boolean {
    return this.data.myRecord != null
  }

  onClickOpenAllEvent() {
    this.eventPage = true
    document.documentElement.scrollTop = 0
  }

  onClickCloseAllEvent() {
    this.eventPage = false
  }

  get isJapanese() {
    return getLanguage() === LANG_JA
  }

  get canUserNativeInterface(): boolean {
    const nativeInterface = defaultNativeInterfaceClient()
    return nativeInterface.client !== Client.native
  }

  onClieckShare() {
    const text = this.getShareText()
    let url = new URL(document.URL)
    url.searchParams.set('adj_t', '8ogcewh_z9yhix5')
    if (this.isJapanese) {
      url.searchParams.set('lang', 'ja')
    }
    if (this.canUserNativeInterface) {
      try {
        const nativeInterface = defaultNativeInterfaceClient()
        nativeInterface.sendEvent('invitation', 'share', {
          text: text,
          linkUrl: url.toString(),
        })
      } catch (e) {}
    }
  }

  getShareText() {
    let text = ''
    if (this.data.myRecord == null) {
      if (this.isJapanese) {
        text += `今年、REALITYを${this.data.totalLoginDays}日遊びました！\n`
        text += `これからもっとREALITYで遊んで、みんなとたくさんの思い出を作っていきたい！\n`
        text += `\n`
        text += `#REALITY思い出アルバム`
      } else {
        text += `This year, I played ${this.data.totalLoginDays} days of REALITY!\n`
        text += `Let's make even more memories on REALITY together!\n`
        text += `\n`
        text += `#REALITYMemories`
      }
      return text
    }

    let view = ''
    let gift = ''
    let collab = ''
    let chat = ''
    let count = 0
    if (this.data.broadcastViewRecords.length > 0) {
      view = this.data.broadcastViewRecords[0].streamerUser.nickname
      count++
    }
    if (this.data.giftRecords.length > 0) {
      gift = this.data.giftRecords[0].giftReceiver.nickname
      count++
    }
    if (this.data.collabRecords.length > 0) {
      collab = this.data.collabRecords[0].collabUser.nickname
      count++
    }
    if (this.data.chatRecords.length > 0) {
      chat = this.data.chatRecords[0].chatUser.nickname
      count++
    }

    if (this.isJapanese) {
      text += `今年、REALITYを${this.data.totalLoginDays}日遊びました！\n`
      text += `2024年、配信を${this.data.myRecord.totalBroadcastHour}時間、視聴を${this.data.myRecord.totalBroadcastViewHour}時間しました！\n`
      text += `\n`
      if (count > 0) {
        text += `最も◯◯した友達はこの${count}人です！\n`
        if (view) text += `視聴：${view}\n`
        if (gift) text += `ギフト：${gift}\n`
        if (collab) text += `コラボ：${collab}\n`
        if (chat) text += `チャット：${chat}\n`
        text += `\n`
      }
      text += `#REALITY思い出アルバム`
    } else {
      text += `This year, I played ${this.data.totalLoginDays} days of REALITY!\n`
      text += `In 2024, I've streamed ${this.data.myRecord.totalBroadcastHour}h & viewed ${this.data.myRecord.totalBroadcastViewHour}h!\n`
      text += `\n`
      if (count > 0) {
        text += `Check out my top friends!\n`
        if (view) text += `Viewer: ${view}\n`
        if (gift) text += `Gifter: ${gift}\n`
        if (collab) text += `Collaber: ${collab}\n`
        if (chat) text += `Chatter: ${chat}\n`
        text += `\n`
      }
      text += `#REALITYMemories`
    }

    return text
  }

  get categoryDescription(): FriendInfoData[] {
    let data: FriendInfoData[] = []
    let count = 0
    if (this.data === undefined) {
      return data
    }

    // 視聴
    if (this.data.broadcastViewRecords.length > 0) {
      const bradcastView = this.data.broadcastViewRecords[0]
      data.push({
        title: this.$t('view'),
        iconUrl: '/img/campaign/reality_memories_2024/icon_play.png',
        name: bradcastView.streamerUser.nickname,
        userIconUrl: bradcastView.streamerUser.iconUrl,
        number: count,
      } as FriendInfoData)
      count++
    }

    // ギフト
    if (this.data.giftRecords.length > 0) {
      const gift = this.data.giftRecords[0]
      data.push({
        title: this.$t('gift'),
        iconUrl: '/img/campaign/reality_memories_2024/icon_gift.png',
        name: gift.giftReceiver.nickname,
        userIconUrl: gift.giftReceiver.iconUrl,
        number: count,
      } as FriendInfoData)
      count++
    }

    // コラボ
    if (this.data.collabRecords.length > 0) {
      const collab = this.data.collabRecords[0]
      data.push({
        title: this.$t('collab'),
        iconUrl: '/img/campaign/reality_memories_2024/icon_collaboration.png',
        name: collab.collabUser.nickname,
        userIconUrl: collab.collabUser.iconUrl,
        number: count,
      } as FriendInfoData)
      count++
    }

    // チャット
    if (this.data.chatRecords.length > 0) {
      const chat = this.data.chatRecords[0]
      data.push({
        title: this.$t('memoriesChat'),
        iconUrl: '/img/campaign/reality_memories_2024/icon_chat.png',
        name: chat.chatUser.nickname,
        userIconUrl: chat.chatUser.iconUrl,
        number: count,
      } as FriendInfoData)
      count++
    }

    return data
  }

  year(dateIso: string): string {
    if (!dateIso) {
      return ''
    }
    const date = new Date(dateIso)
    return date.getFullYear().toString()
  }

  monthAndDay(dateIso: string): string {
    if (!dateIso) {
      return '--'
    }
    return dayjs(dateIso).format('MM/DD')
  }

  fullDate(dateIso: string): string {
    if (!dateIso) {
      return '--'
    }
    return dayjs(dateIso).format('YYYY/MM/DD')
  }
}
</script>

<style scoped>
.theme_accent80 {
  color: #C0B6FF;
}

.theme_Liner_2022-to-2023 {
  color: #C0B6FF;
  background: linear-gradient(
    90deg,
    #246991 0%,
    #6322DB 52.6%,
    #C32B82 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.theme_gray {
  color: rgba(255, 255, 255, 0.8);
}

.theme_black {
  color: #262626;
}

.index {
  width: 375px;
  background-image: url('/img/campaign/reality_memories_2024/background.png');
  position: relative;
  font-family: -apple-system, BlinkMacSystemFont;
  color: #000000;
}

.logo {
  position: absolute;
  width: 200px;
  height: 40px;
  left: 4px;
  top: 16px;
}

.background_up_right {
  position: absolute;
  width: 220px;
  height: 300px;
  left: 155px;
  top: 0px;
}

.Frame1 {
  padding: 0px;
  position: relative;
  width: 343px;
  padding-top: 64px;
  z-index: 1;
}

.Group1-1 {
  width: 343px;
  height: 124px;

  flex: none;
  order: 0;
  flex-grow: 0;
  position: relative;
}

.Group1-1-1 {
  position: absolute;
  width: 222px;
  height: 109px;
  left: 0px;
  top: 8px;
}

.Group1-1-1 .text1 {
  display: -webkit-box;
  flex-direction: column;
  align-items: center;
  padding: 0px 8px;

  position: absolute;
  height: 21px;
  left: 0px;
  top: 8px;

  background: #ffffff;

  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
}

.Group1-1-1 .text2 {
  display: -webkit-box;
  position: absolute;
  height: 51px;
  left: 0px;
  top: 37px;
  padding-right: 6px;

  background: #ffffff;
}

.Group1-1-1 .text2 p {
  font-weight: 943;
  font-size: 34px;
  padding-left: 8px;

  position: relative;
  height: 42px;
}

.Group1-1-1 .text2 img {
  position: relative;
  height: 42px;
  top: 4px;
}

.Group1-1-1 .text3 {
  display: -webkit-box;
  flex-direction: column;
  align-items: center;
  padding: 0px 8px;

  position: absolute;
  height: 21px;
  left: 0px;
  top: 96px;

  background: #ffffff;

  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
}

.Group1-1-2 {
  position: absolute;
  width: 124px;
  height: 124px;
  left: 219px;
  top: 0px;
  filter: drop-shadow(0px 0px 4px rgba(100, 100, 100, 0.2));
  background: #ffffff;
}

.Group1-1-2 img {
  position: absolute;
  width: 108px;
  height: 108px;
  left: 8px;
  top: 8px;
}

.Frame1-2 {
  width: 343px;
  padding-top: 12px;
}

.Frame1-2-2 p {
  position: relative;
  height: 17px;
  left: 0px;
  top: 0px;

  font-weight: 300;
  font-size: 11px;
  line-height: 16px;
}

.Frame1-2-2 {
  position: relative;
  padding: 0px;
  margin-top: 8px;

  width: 343px;
  height: 105px;
}

.Frame1-2-1-1 {
  position: absolute;
  width: 343px;
  height: 88px;
  left: 0px;
  top: 21px;
}

.ResultFrame1 {
  width: 167.5px;
  height: 88px;

  background: rgba(33, 33, 33, 0.8);
  border-radius: 4px;
}

.ResultFrame1.left {
  position: absolute;
  left: 0px;
}

.ResultFrame1.right {
  position: absolute;
  right: 0px;
}

.ResultFrame1 .title {
  position: absolute;
  height: 17px;
  left: 8px;
  top: 8px;

  font-weight: 300;
  font-size: 11px;
  line-height: 16px;
}

.ResultFrame1 .year {
  position: absolute;
  height: 45px;
  left: 8px;
  top: 15px;

  font-weight: 900;
  font-size: 16px;
  line-height: 90.4%;

  display: -webkit-box;
  align-items: center;
}

.ResultFrame1 .date {
  position: absolute;
  height: 45px;
  left: 8px;
  top: 42px;

  font-weight: 900;
  font-size: 29px;

  display: -webkit-box;
  align-items: center;
}

.ResultFrame1 .hour {
  position: absolute;
  height: 45px;
  left: 8px;
  top: 38px;

  font-weight: 900;
  font-size: 29px;

  display: -webkit-box;
  align-items: center;
}

.ResultFrame1 img {
  position: absolute;
  width: 65px;
  height: 65px;
  left: 102px;
  top: 0px;
}

.Group1-2-3 {
  position: relative;
  margin-top: 8px;
  width: 343px;
  background: rgba(33, 33, 33, 0.8);
  background: rgba(33, 33, 33, 0.8);
  border-radius: 4px;
}

.Group1-2-3 .BackIcon {
  position: absolute;
  width: 65px;
  height: 65px;
  left: 278px;
  top: 0px;
}

.Group1-2-3 .title {
  width: 327px;
  height: 17px;

  font-weight: 300;
  font-size: 11px;
  line-height: 16px;

  display: -webkit-box;
  align-items: center;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.Group1-2-3 .OpenButton {
  width: 343px;
  padding-top: 8px;
  padding-bottom: 15px;
}

.Group1-2-3 .OpenButton p {
  width: 100px;
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  margin: 0 auto;
}

.Frame1-2-3-1 {
  display: -webkit-box;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px;
  gap: 8px;

  width: 327px;
}

.Group1-3 {
  padding-top: 20px;
}

.Group1-3 p {
  font-weight: 300;
  font-size: 11px;
  line-height: 16px;
}

.Group1-3-1 {
  padding: 60px 16px;

  position: relative;
  width: 343px;
  height: 352px;
  left: 0px;

  background: rgba(33, 33, 33, 0.8);
  border-radius: 4px;
}

.Group1-3-1 img {
  position: relative;
  width: 120px;
  height: 120px;
  left: calc(50% - 120px / 2);
}

.Group1-3-1 p {
  width: 311px;
  height: 96px;

  font-weight: 300;
  font-size: 16px;
  line-height: 24px;

  color: #ffffff;
}

.Group2 {
  display: -webkit-box;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;

  position: relative;
  width: 343px;
  padding-top: 32px;
}

.background_center_left {
  position: absolute;
  width: 250px;
  height: 362px;
  left: -15px;
  top: -68px;
  z-index: 0;
}

.Group2-1 {
  position: relative;
  width: 334px;
  height: 124px;
  left: 0px;
  top: 0px;
}

.Frame2-1-1 {
  display: -webkit-box;
  flex-direction: column;
  align-items: center;
  padding: 0px 8px;

  position: absolute;
  height: 27px;
  left: 100px;
  top: 31px;

  background: #ffffff;
}

.Frame2-1-1 p {
  height: 27px;

  font-weight: 600;
  font-size: 18px;
  line-height: 27px;

  color: #000000;

  flex: none;
  order: 0;
  flex-grow: 0;
}

.Frame2-1-2 {
  display: -webkit-box;
  flex-direction: column;
  align-items: center;
  padding: 0px 8px;

  position: absolute;
  height: 27px;
  left: 100px;
  top: 66px;

  background: #ffffff;
}

.Frame2-1-2 p {
  height: 27px;

  font-weight: 600;
  font-size: 18px;
  line-height: 27px;

  color: #000000;

  flex: none;
  order: 0;
  flex-grow: 0;
}

.Group2-1-3 {
  position: absolute;
  width: 124px;
  height: 124px;
  top: 0px;
  background-color: #ffffff;
  filter: drop-shadow(0px 0px 4px rgba(100, 100, 100, 0.2));
}

.Group2-1-3 img {
  position: absolute;
  width: 108px;
  height: 108px;
  left: 8px;
  top: 8px;
}

.Group2-2 {
  position: relative;
  width: 343px;
  left: 0px;
  top: 8px;
}

.Frame2-2-1 p {
  width: fit-content;
  height: 21px;
  padding: 0px 8px;

  font-weight: 300;
  font-size: 14px;
  line-height: 21px;

  color: #ffffff;

  background: linear-gradient(90deg, #246991 0%, #6322DB 52.6%, #C32B82 100%);
}

.Group2-2-2 {
  position: relative;
  width: 343px;
  height: 260px;
  left: 0px;
  top: 0px;
}

.Frame3 {
  position: relative;
  left: 0px;
  padding: 0px;
  padding-top: 32px;
}

.Group3-1 {
  position: relative;
  width: 323px;
  margin-bottom: 62px;
}

.Group3-1-1 {
  position: absolute;
  left: 223px;
  top: 0px;
  width: 120px;
  height: 120px;

  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
  background-color: #ffffff;
}

.Group3-1-1 img {
  position: absolute;
  left: 8px;
  top: 8px;
  width: 104px;
  height: 104px;
}

.Group3-1-2 {
  background: rgba(33, 33, 33, 0.8);
  border-radius: 4px;

  position: relative;
  top: 34px;
  left: 10px;
  padding: 16px;
  width: 323px;
}

.Group3-1-2 .title {
  position: absolute;
  top: 16px;

  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  width: 189px;
}

.Group3-1-2 .name {
  position: absolute;
  top: 38px;

  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  max-width: 189px;
}

.Group3-1-2 .description {
  position: relative;
  padding-top: 88px;

  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  padding-bottom: 16px;
}

.Group3-1-2-1 {
  position: relative;
  padding-top: 16px;
}

.Group3-2 {
  position: relative;
  width: 323px;
  margin-bottom: 62px;
}

.Group3-2-1 {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 120px;
  height: 120px;

  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
  background-color: #ffffff;
}

.Group3-2-1 img {
  position: absolute;
  left: 8px;
  top: 8px;
  width: 104px;
  height: 104px;
}

.Group3-2-2 {
  background: rgba(33, 33, 33, 0.8);
  border-radius: 4px;

  position: relative;
  top: 34px;
  left: 10px;
  padding: 16px;
  width: 323px;
}

.Group3-2-2 .title {
  position: absolute;
  top: 16px;
  left: 120px;

  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  width: 189px;
}

.Group3-2-2 .name {
  position: absolute;
  top: 38px;
  left: 120px;

  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  max-width: 189px;
}

.Group3-2-2 .description {
  position: relative;
  padding-top: 88px;
  left: 76px;
  width: 223px;

  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  padding-bottom: 16px;
}

.Group3-2-2 .gift_icon {
  position: absolute;
  top: 100px;
  left: 24px;
  width: 60px;
  height: 60px;
}

.Group3-2-2-1 {
  position: relative;
  padding-top: 16px;
}

.Group3-3 {
  position: relative;
  width: 323px;
  margin-bottom: 62px;
}

.Group3-3-1 .icon_right {
  position: absolute;
  right: 5px;
  top: 0px;
  width: 120px;
  height: 120px;

  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
  background-color: #ffffff;
}

.Group3-3-1 .icon_x {
  position: absolute;
  left: 156px;
  top: 46px;
  width: 32px;
  height: 32px;
}

.Group3-3-1 .icon_left {
  position: absolute;
  left: 26px;
  top: 0px;
  width: 120px;
  height: 120px;

  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
  background-color: #ffffff;
}

.Group3-3-1 img {
  position: absolute;
  left: 8px;
  top: 8px;
  width: 104px;
  height: 104px;
}

.Group3-3-2 {
  background: rgba(33, 33, 33, 0.8);
  border-radius: 4px;

  position: relative;
  top: 34px;
  left: 10px;
  padding: 16px;
  width: 323px;
}

.Group3-3-2 .title {
  position: relative;
  padding-top: 90px;

  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  width: 100%;
  text-align: center;
}

.Group3-3-2 .name {
  display: inline-block;
  position: relative;
  padding-top: 5px;

  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  max-width: 100%;
  text-align: center;
}

.Group3-3-2 .description {
  position: relative;
  padding-top: 12px;

  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  padding-bottom: 16px;
}

.Group3-3-2-1 {
  position: relative;
  padding-top: 16px;
}

.Group3-4 {
  position: relative;
  width: 323px;
  margin-bottom: 62px;
}

.Group3-4-1 {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 120px;
  height: 120px;

  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
  background-color: #ffffff;
}

.Group3-4-1 img {
  position: absolute;
  left: 8px;
  top: 8px;
  width: 104px;
  height: 104px;
}

.Group3-4-2 {
  background: rgba(33, 33, 33, 0.8);
  border-radius: 4px;

  position: relative;
  top: 34px;
  left: 10px;
  padding: 16px;
  width: 323px;
}

.Group3-4-2 .title {
  position: absolute;
  top: 16px;
  left: 120px;

  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  width: 189px;
}

.Group3-4-2 .name {
  position: absolute;
  top: 38px;
  left: 120px;

  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  max-width: 189px;
}

.Group3-4-2 .description {
  position: relative;
  padding-top: 88px;

  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  padding-bottom: 16px;
}

.Group3-4-2-1 {
  position: relative;
  padding-top: 16px;
}

.Frame4 {
  position: relative;
  width: 343px;
  left: 0px;
  padding-top: 42px;
  padding-bottom: 80px;
}

.Frame4 p {
  position: relative;

  font-weight: 300;
  font-size: 14px;
  line-height: 21px;

  text-align: center;

  color: #ffffff;
}

.share_button {
  position: relative;
  left: calc(50% - 220px / 2);
  width: 220px;
  height: 40px;
  padding: 8px 16px;
  margin-top: 16px;

  background: linear-gradient(90deg, #246991 0%, #6322DB 52.6%, #C32B82 100%);
  border-radius: 30px;

  font-weight: 600;
  font-size: 12px;
  line-height: 24px;

  text-align: center;

  color: #ffffff;
}

.share_button img {
  width: 24px;
  height: 24px;
}

.Frame4 .anniversary_logo {
  position: relative;
  width: 100px;
  height: 74.51px;
  left: calc(50% - 100px / 2);
  margin-top: 18px;
}

.Frame4 .anniversary_logo img {
  width: 100px;
  height: 74.51px;
}

.Frame5 {
  padding-bottom: 100px;
  min-height: 768px;
}

.Frame5 .close_button {
  position: sticky;
  width: 44px;
  height: 44px;
  left: calc(50% - 44px / 2 + 150px);
  top: 16px;
  z-index: 1;
}

.Frame5 .close_button img {
  width: 44px;
  height: 44px;
}

.Frame5 .EventTitle {
  height: 36px;

  font-weight: 600;
  font-size: 24px;
  line-height: 36px;

  color: #000000;
}
.Frame5 .EventTitle .text1 {
  position: absolute;
  top: 32px;
  padding: 0px 8px;
  height: 36px;

  background: #ffffff;
}

.Frame5 .EventTitle .text2 {
  position: absolute;
  top: 76px;
  height: 36px;
  padding: 0px 8px;

  background: #ffffff;
}

.Frame5-0 {
  display: -webkit-box;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 0px;
  gap: 8px;

  position: relative;
  width: 343px;
  margin-top: 57px;
  padding-top: 15px;
}
.Frame5-0 p {
  font-weight: 300;
  font-size: 11px;
  line-height: 16px;

  display: -webkit-box;
  align-items: center;
}

.Frame5-1 {
  display: -webkit-box;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 8px;
  gap: 8px;

  position: relative;
  width: 343px;
  padding-top: 15px;

  background: rgba(33, 33, 33, 0.8);
  border-radius: 4px;
}

.Frame5-1 p {
  font-weight: 300;
  font-size: 11px;
  line-height: 16px;

  display: -webkit-box;
  align-items: center;
}
</style>
